<template>
  <validation-observer
    :ref="'addNewDocumentObserver'"
    tag="div"
    v-slot="{invalid, valid, untouched, errors}"
  >
    <div class="card">
      <div class="card-header">
        <h2
          class="card-header-title is-size-4 has-background-primary has-text-white"
        >Add a Certificate Document</h2>
      </div>
      <div class="card-content">
        <div class="column is-12">
          <input-with-validation
            :rules="'required'"
            :model="certificate_document.name"
            :vuexKey="'name'"
            :label="'Certificate/Clearance Name'"
            :errorLabel="`Certificate/Clearance Name`"
            :name="`certificateClearanceName`"
            :placeholder="'Certificate/Clearance Name'"
            :type="'textarea'"
            @input="updateVuex"
          ></input-with-validation>
        </div>

        <div class="column is-12 file-wrapper">
          <file-upload-input-with-validation
            v-if="hasCertificateName"
            :rules="'required'"
            :name="`certificateClearanceFile`"
            :model="certificate_document.file"
            :vuexKey="'file'"
            :label="'Select File'"
            :errorLabel="'File'"
            @input="uploadFile"
          ></file-upload-input-with-validation>
          <button
            v-if="!hasCertificateName"
            class="button is-primary has-width-200"
            @click="validateInput"
          >
            <b-icon icon="upload" class="has-margin-right-10"></b-icon>Select File
          </button>
          <b-loading :is-full-page="true" :active.sync="uploading" :can-cancel="false"></b-loading>
        </div>
      </div>
    </div>
    <div class="columns"></div>
  </validation-observer>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import FileUploadInputWithValidation from "./form-inputs/FileUploadInputWithValidation";
import InputWithValidation from "./form-inputs/InputWithValidation";

import UploadCertificateDocumentMutation from "@/modules/shippersModule/api/graphql/mutations/UploadCertificateDocument";

import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
import { mapGetters as mapRootGetters } from "vuex";
const { mapMutations, mapGetters } = createNamespacedHelpers("shippers");

export default {
  name: "AddCertificateDocument",

  components: {
    InputWithValidation,
    FileUploadInputWithValidation,
    ValidationObserver
  },

  props: {
    certificate_document: { type: Object, required: true }
  },

  data() {
    return {
      uploading: false
    };
  },

  computed: {
    ...mapRootGetters({
      userID: "getUserID"
    }),

    ...mapGetters({
      shippingRequestID: "getShippingRequestID"
    }),

    hasCertificateName() {
      if (this.certificate_document.name) {
        return true;
      }

      return false;
    }
  },

  methods: {
    ...mapMutations({
      commitCertificateDocumentsUpdate:
        SHIPPER_MUTATION_TYPES.UPDATE_CERTIFICATE_DOCUMENTS,
      commitUploadedCertificateDocument:
        SHIPPER_MUTATION_TYPES.ADD_UPLOADED_CERTIFICATE_DOCUMENT,
      resetCertificateDocumentState:
        SHIPPER_MUTATION_TYPES.RESET_CERTIFICATE_DOCUMENTS
    }),

    /**
     * Update the vuex store when the name of a certificate document is changed
     */
    updateVuex({ key, value }) {
      this.commitCertificateDocumentsUpdate({
        index: 0,
        keyName: key,
        value
      });
    },

    /**
     * Handle certificate document file upload
     */
    uploadFile({ key, value }) {
      // Handle File upload here
      this.uploading = true;

      this.$apollo
        .mutate({
          mutation: UploadCertificateDocumentMutation,
          variables: {
            input: {
              shipping_request_id: this.shippingRequestID,
              file_name: this.certificate_document.name,
              file: value
            }
          }
        })
        .then(response => {
          const documentDetails =
            response.data.UploadShippingRequestSupportingDocument;
          this.commitUploadedCertificateDocument(documentDetails);
          this.resetCertificateDocumentState();
          this.$toast.open({
            duration: 4000,
            message: "Document uploaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          console.error(error);
          this.$toast.open({
            duration: 4000,
            message: "Document upload failed. Please try again",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.uploading = false;
          this.$parent.close();
        });

      this.commitCertificateDocumentsUpdate({
        index: 0,
        keyName: key,
        value
      });
    },

    /**
     * Validate the text input for the certificate name
     */
    async validateInput() {
      const isValid = await this.$refs.addNewDocumentObserver.validate();
      if (!isValid) {
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.file-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>